/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { RenderModule, composeModules } from 'holocron';
import SharedScripts, { Dynatrace, GtagWrapper } from '@americanexpress/shared-scripts';
import { legacyLoadProducts } from 'axp-product-ducks';
import { configureIguazuSSR } from 'iguazu-holocron';

import { reducer, mapDispatchToProps } from '../ducks';
import childRoutes from '../childRoutes';
import DataLayer from './DataLayer';
import OneXp from './OneXp';
import {
  onLoadInAuth,
  showHeaderFooter,
  isSas,
  isUpgrade,
  isUs,
} from '../utils';

export const AxpSuppRoot = ({
  // eslint-disable-next-line no-unused-vars
  locale, children, actSetInAuthUUID, location: { pathname }, channel,
}) => (
  <div>
    <Helmet
      {...{
        htmlAttributes: {
          lang: locale,
        },
        title: 'American Express',
        meta: [
          { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
          { charset: 'utf-8' },
          { name: 'viewport', content: 'width=device-width, initial-scale=1' },
          { name: 'application-name', content: 'American Express' },
        ],
      }}
    />
    <SharedScripts
      name="inauth"
      windowCheck="inauthSetTid"
      version="^1.1.0"
      onload={onLoadInAuth(actSetInAuthUUID)}
    />
    {isUs(pathname) && (
      <GtagWrapper version="^1.0.0" />
    )}
    <Dynatrace version="^1.0.0" appId="514A21B38C4F4C7C" />
    <OneXp locale={locale} pathname={pathname}>
      {
        showHeaderFooter({ locale, pathname })
        && !(isUs(pathname) && isSas(pathname))
        && !(isUs(pathname) && isUpgrade(pathname))
          ? (
            <>
              <RenderModule moduleName="axp-global-header" />
              <DataLayer
                locale={locale}
                pathname={pathname}
                channel={channel}
              >
                {children}
              </DataLayer>
              <RenderModule moduleName="axp-footer" />
            </>
          ) : (
            <DataLayer
              locale={locale}
              pathname={pathname}
              channel={channel}
            >
              {children}
            </DataLayer>
          )
      }
    </OneXp>
  </div>
);

AxpSuppRoot.childRoutes = childRoutes;

// eslint-disable-next-line no-unused-vars
export const loadModuleData = async ({ store, module, ownProps }) => {
  const { dispatch } = store;
  await dispatch(loadLanguagePack('axp-card-member-apply-root', { fallbackLocale: 'en-US' }));
  await dispatch(composeModules([{ name: 'axp-global-header' }, { name: 'axp-footer' }]));
  const appParam = store
    .getState()
    .getIn(['modules', 'axp-card-member-apply-root', 'query', 'appParam']);
  if (!appParam && global.BROWSER) {
    await dispatch(legacyLoadProducts());
  }
  await configureIguazuSSR({ store, module, ownProps });
};

AxpSuppRoot.holocron = {
  name: 'axp-card-member-apply-root',
  loadModuleData,
  reducer,
};

AxpSuppRoot.propTypes = {
  locale: PropTypes.string,
  actSetInAuthUUID: PropTypes.func.isRequired,
  channel: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line global-require
  AxpSuppRoot.appConfig = require('../appConfig').default;
}

export const mapStateToProps = (state) => {
  const channel = state.getIn(['modules', 'axp-card-member-apply-root', 'body', 'channel']);
  return {
    channel,
  };
};

const hocChain = compose(
  oneAppModuleWrapper('axp-card-member-apply-root'),
  connect(mapStateToProps, mapDispatchToProps)
);

export default hocChain(AxpSuppRoot);
